import React, {
  memo, useCallback, useEffect, useMemo, useRef,
} from 'react'

import DesignerContent from 'Pods/SearchPage/Shared/DesignerContent/DesignerContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

// Same as the File format dropdown: the panel animates open, and focusing before it is in place
// scrolls the page to an input that is not yet visible.
const SEARCH_FOCUS_DELAY = 300

function Designer() {
  const translate = useTranslate()
  const searchRef = useRef(null)
  const focusTimerRef = useRef(null)

  const designers = useSearchPageStore(state => state.designers ?? EMPTY_ARRAY)
  const scopes = useSearchPageStore(state => state.designerScopes ?? EMPTY_ARRAY)

  // One value per entry getFiltersCount counts, so "Designer +n" matches what "Clear all filters"
  // adds for this filter. A whole-scope flag (Following) stands in for its members.
  const selectedValues = useMemo(() => [
    ...scopes.map(scope => translate(`search_page.filters.designers.${scope}`)),
    ...designers,
  ], [designers, scopes, translate])

  useEffect(() => () => {
    clearTimeout(focusTimerRef.current)
  }, [])

  const handleOpenChange = useCallback((isOpen) => {
    // A close inside the delay must cancel the pending focus, or the hidden input would take focus
    // (and scroll the page to itself) after the panel is gone.
    clearTimeout(focusTimerRef.current)
    if (!isOpen || !searchRef.current) {
      return
    }
    focusTimerRef.current = setTimeout(() => {
      searchRef.current?.focus()
    }, SEARCH_FOCUS_DELAY)
  }, [])

  // DesignerContent keeps its own Reset here: it is the only place that can resolve a scope flag
  // back into a designer count. Only the list scrolls, as in File format, so the search field and
  // Reset stay put (see .designer-filter__popover-content).
  const content = useMemo(() => <DesignerContent searchRef={searchRef} isListScrollable />, [])

  return (
    <FiltersWrapper
      trailIconSize="small"
      placeholder={translate('search_page.filters.designers.title')}
      content={content}
      onOpenChange={handleOpenChange}
      hasSelectedAnyFilters={selectedValues.length > 0}
      selectedValues={selectedValues}
      positionHorizontal="left"
      closingDropdownClassName="filter-wrapper main-filters__min-width-dropdown"
      contentClassName="designer-filter__popover-content"
    />
  )
}

export default memo(Designer)
